// extracted by mini-css-extract-plugin
export default {"chatContainer":"StudentAssignmentMessaging__chatContainer___zczeC"};